<template>
  <div class="common-sign">
    <vue-esign :class="{'is-invisible': qrcodeMode}"
               ref="sign"
               v-bind="$extend($attrs, $props)" />
    <template v-if="qrcodeMode">
      <div class="qrcode-wrap"
           v-loading="loading">
        <template v-if="signData">
          <img :src="signData" alt="签名" />
        </template>
        <template v-else>
          <div class="title">
            <span class="theme-text">手机扫描下方二维码进行签名</span>
          </div>
          <div class="scan-wrap">
            <QrcodeContainer ref="qrcode"
                             class="qrcode"
                             :text="qrcodeLink"></QrcodeContainer>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import VueEsign from 'vue-esign'
import QrcodeContainer from '../elements/QrcodeContainer'
import pathUtils from '../../util/pathUtils'
export default {
  name: 'CommonSign',
  components: {
    VueEsign,
    QrcodeContainer
  },
  props: {
    width: {
      type: Number,
      default: 800
    },
    height: {
      type: Number,
      default: 300
    },
    qrcodeMode: Boolean
  },
  data () {
    return {
      signData: null,
      subscribe: {
        handler: null
      },
      loading: false
    }
  },
  computed: {
    ...mapState({
      accountObj: state => state.account,
      stompClient: state => state.stomp.client
    }),
    userKey () {
      return this.accountObj.loginId
    },
    signKey () {
      return `sign_${Date.now()}`
    },
    qrcodeLink () {
      return window.location.origin + window.location.pathname + `#/common/sign/${this.userKey}/${this.signKey}`
    }
  },
  methods: {
    generate () {
      if (this.qrcodeMode) {
        return new Promise(resolve => {
          if (this.signData) {
            resolve(this.signData)
          } else {
            this.loading = true
            this.$ajax({
              url: `/workspace/manager/plat/common/sign/get/${this.signKey}`,
              method: 'post'
            }).then(response => {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  const signature = response.data['data']
                  if (signature) {
                    this.signData = signature
                    this.$nextTick(() => {
                      resolve(signature)
                    })
                  } else {
                    resolve('')
                  }
                  break
                }
                default: {
                  this.$message.warning(response.data['message'])
                  resolve('')
                  break
                }
              }
            }, () => {
              this.$message.error('请求发送失败，请稍后重试')
              resolve('')
            }).finally(() => {
              this.loading = false
            })
          }
        })
      } else {
        return new Promise((resolve, reject) => {
          let sign = this.$refs.sign
          if (sign) {
            sign.generate()
              .then(resolve)
              .catch(() => resolve(''))
          } else {
            reject(new Error('签名组件未初始化'))
          }
        })
      }
    },
    reset () {
      if (this.qrcodeMode) {
        this.signData = null
      } else {
        let sign = this.$refs.sign
        if (sign) {
          sign.reset()
        }
      }
    },
    handleSubscribe () {
      if (this.stompClient && !this.subscribe.handler) {
        this.subscribe.handler = this.stompClient
          .subscribe('/receiveUser/subscribeTopic/common/sign/notification',
            data => this.handleReceiveData(data))
      }
    },
    handleUnsubscribe () {
      this.subscribe.handler && this.subscribe.handler.unsubscribe()
      this.subscribe.handler = null
    },
    handleReceiveData (data) {
      if (data && data.body) {
        let dataBody = JSON.parse(data.body)
        if (dataBody) {
          if (dataBody.key === this.signKey) {
            this.signData = dataBody.data
          }
        }
      }
    }
  },
  beforeDestroy () {
    this.handleUnsubscribe()
  },
  watch: {
    qrcodeMode: {
      handler (val) {
        if (val) {
          this.handleSubscribe()
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .common-sign {
    position: relative;
    canvas {
      width: 100%!important;
      height: 100%!important;
    }
    .is-invisible {
      visibility: hidden;
    }
    .qrcode-wrap {
      position: absolute;
      inset: 0;
      background-color: #fff;
      z-index: 99;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &>.title {
        font-size: 12px;
        text-align: center;
      }
      &>.scan-wrap {
        margin: 4px auto 10px;
        border: 1px solid #606266;
        box-shadow: 0 0 3px rgba(0,0,0,.15);
        width: 100px;
        height: 100px;
        padding: 3px;
        &>.qrcode {
          width: 100%;
          height: 100%;
        }
      }
      &>img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
</style>
